import { useEffect, useState } from "react";

import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

const useTasks = () => {
    const { platformId } = useParams();
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const { clientId } = useParams();
    const [data, setData] = useState({ tasks: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });

    const handleModalConfig = (row = {}) => {
        setModalConfig(prev => ({ row, isOpen: !prev.isOpen }));
    };

    const getTasks = async ({ page, limit }) => {
        const { data, pagination } = await axiosInstance.get(`/tasks/${platformId}`, {
            params: {
                page,
                limit,
                clientId
            }
        });
        
        setData({
            tasks     : data,
            pagination: pagination || {}
        });
    };

    const handlePagination = ({ page = 1, limit = 10 }) => {
        getTasks({ page, limit });
    };

    const handleRowActions = async (row = {}, action) => {
        if (["delete", "markDone"].includes(action)) {
            if (action === "delete") {
                await axiosInstance.delete(`/tasks/${platformId}/${row.id}`);
            } 
            if (action === "markDone") {
                await axiosInstance.patch(`/tasks/${platformId}/${row.id}`, {
                    description: row.description,
                    dueDate    : row.dueDate,
                    name       : row.name,
                    status     : "done"  
                });
            }
            getTasks({ page: 1, limit: 10 });
            return;

        } 
        handleModalConfig(row);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getTasks({ page: 1, limit: 10 });
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        getTasks,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        isOpen: modalConfig.isOpen,
        handleRowActions,
        handlePagination
    };
};

export default useTasks;